import { TimeEntry } from "../models/time-entry.model";
import { UuidAndId } from "../models/uuid-and-id";
import { TimeEntryStateModel } from "../state/time-entry.state";

export namespace TimeEntryActions {
    export class Refresh {
        static readonly type = '[API-TIME-ENTRY] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-TIME-ENTRY] Increment Pending Count'
        constructor() {}
    } 
    export class Init {
        static readonly type = '[Storage-TIME-ENTRY] Init'
        constructor(public payload: TimeEntryStateModel) {}
    }
    export class Set {
        static readonly type = '[API-TIME-ENTRY] Set'
        constructor(public payload: TimeEntry[]) {}
    }
    export class Merge {
        static readonly type = '[API-TIME-ENTRY] Merge'
        constructor(public payload: TimeEntry[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-TIME-ENTRY] Add One'
        constructor(public payload: TimeEntry) {}
    }    
    export class UpdateOne {
        static readonly type = '[UI-TIME-ENTRY] Update One'
        constructor(public payload: TimeEntry) {}
    }       
    export class DeleteOne {
        static readonly type = '[UI-TIME-ENTRY] Delete One'
        constructor(public payload: TimeEntry) {}
    }     
    export class ApiAddedOne {
        static readonly type = '[API-TIME-ENTRY] Added One'
        constructor(public payload: TimeEntry) {}
    }
    export class ApiUpdatedOne {
        static readonly type = '[API-TIME-ENTRY] Updated One'
        constructor(public payload: TimeEntry) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-TIME-ENTRY] Deleted One'
        constructor(public payload: UuidAndId) {}
    }     
}
